import React, { Suspense, useEffect, useRef } from "react";
import { ICreateComponentSuspenseOptions, ICreateInitial } from "./type";
import LoadingSquare from "./Components/LoadingSquare";

function generateUID() {
    return 'uid-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 5);
}
export const MountComponent = (props: { initial: ICreateInitial, className?: string, mcfeId?: string }) => {
    const { initial } = props
    const id = useRef(props.mcfeId || generateUID())
    useEffect(() => {
        initial.mount('#' + id.current)
        return () => {
            initial.unmount()
        }
    }, [])
    return <div id={id.current} className={props.className} />
}
export const CreateMountComponent = (initial: ICreateInitial) => {
    const Component = (props: any) => {
        return <MountComponent  {...props} initial={initial} />
    }
    return Component
}
// import('LayoutReact/App1').
export const CreateComponent = (loading: Promise<any>) => {
    const Comp = React.lazy(() => loading.then((module) => {
        return { default: CreateMountComponent(module.default) };
    }));
    return Comp
}
export const CreateComponentModule = (loading: Promise<any>, error?: React.ComponentType<any>) => {
    const _Error = error ?? ErrorComponent;
    return loading.then((module) => {
        return { default: CreateMountComponent(module.default) };
    }).catch(() => {
        return { default: () => <_Error /> };
    })
}
export const CreateComponentLazy = CreateComponent

const ErrorComponent = () => <div>Error loading module</div>
export const CreateComponentSuspense = function <TProps extends { className?: string, mcfeId?: string }>(loading: Promise<any>, options?: ICreateComponentSuspenseOptions) {
    const Comp = React.lazy(() => CreateComponentModule(loading, options?.ErrorComponent));
    let LoadingComponent = options?.LoadingComponent
    if (!LoadingComponent) {
        LoadingComponent = LoadingSquare
    }
    return (props: TProps) => <Suspense fallback={<LoadingComponent />}>
        <Comp {...props} mcfeId={props.mcfeId ?? options?.mcfeId} className={props.className ?? options?.className ?? "mfe-module-mount"} />
    </Suspense>
}
